/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'
import { apiContext } from 'services/ApiContext'
import './style.scss'
import { useDidUpdateEffect } from 'services/utils'
import CompanyDisplayImage from 'components/DashboardComponents/CompanyDisplayImage'
import UploadImage from 'components/DashboardComponents/CompanyDisplayImage/UploadImage'

const TestPage = () => {
  const { rounds } = useContext(apiContext)
  const [round, setRound] = useState(rounds[0])

  useDidUpdateEffect(() => {
    const updatedRound = rounds.find((r) => r.id === round.id)
    setRound(updatedRound || rounds[0])
  }, [rounds])
  return (
    <div>
      <CompanyDisplayImage overridable />
      {/* VERTICAL LOGO - changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable
          overridable
          project={{
            company: {
              companyLogoURL:
                'https://storage.googleapis.com/ventury-extra-items/vertical_logo.png',
            },
          }}
          user={{}}
          disableEdit={false}
        />
      </div>
      {/* VERTICAL LOGO - non-changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable
          overridable
          project={{
            company: {
              companyLogoURL:
                'https://storage.googleapis.com/ventury-extra-items/vertical_logo.png',
            },
          }}
          user={{}}
          disableEdit={false}
        />
      </div>
      {/* HORIZONTAL LOGO - changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable
          overridable
          project={{
            company: {
              companyLogoURL:
                'https://storage.googleapis.com/ventury-extra-items/horizontal_logo.png',
            },
          }}
          user={{}}
          disableEdit={false}
        />
      </div>
      {/* HORIZONTAL LOGO - non-changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable={false}
          overridable={false}
          project={{
            company: {
              companyLogoURL:
                'https://storage.googleapis.com/ventury-extra-items/horizontal_logo.png',
            },
          }}
          user={{}}
          disableEdit={false}
        />
      </div>
      {/* NO LOGO - changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable
          overridable
          project={{ company: {} }}
          user={{}}
          disableEdit={false}
        />
      </div>
      {/* NO LOGO - non-changeable */}
      <div className="company-display-image">
        <UploadImage
          changeable={false}
          overridable={false}
          project={{ company: {} }}
          user={{}}
          disableEdit={false}
        />
      </div>

      {/* UPLOADED LOGO - changeable */}
      <CompanyDisplayImage />
      {/* UPLOADED LOGO - non-changeable */}
      <CompanyDisplayImage changeable overridable />
    </div>
  )
}

export default TestPage
